import { grpc } from '@improbable-eng/grpc-web'
import config from '@/config'
import { Toast } from 'vant';
const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : process.env.VUE_APP_BUILD === 'production' ? config.baseUrl.pro : config.baseUrl.alp
const invoke = (url, params,prefix) => {
  return new Promise(function (resolve) {
    let result
    grpc.invoke(url, {
      request: params,
      host: prefix?prefix:baseUrl,
      onMessage: (message) => {
        result = message.toObject()
      },
      onEnd: (code, message, trailers) => {
        if (code !== grpc.Code.OK) {
          const errorList = message.split(',')[0]
          const status = parseInt(errorList.split(':')[1])
          if (status === 251) {
            Toast.fail('数据已存在，不能进行此操作')
          } else if (status === 252) {
            Toast.fail('数据使用中，不能执行此操作')
          } else if (status === 102) {
            // Toast.fail({duration:0,message:'现场视频记录'})
          } else if (status === 812 || status === 107) {
            Toast.fail('登录过期，请重新登录')
            location.reload()
            localStorage.clear()
          } else if (status === 816) {
            Toast.fail('用户不存在')
          } else if (status === 803) {
            Toast.fail('验证码不正确')
          } else {
            // Toast.fail('参数不完整')
          }
          console.log(code, message, trailers)
          resolve()
        } else {
          console.log(result)
          resolve(result)
        }
      }
    })
  })
}
export default {
  invoke: invoke
}
